/**
 * Temporary mapping from old "Engagement" event titles to new "Assignment" titles.
 * This mapping bridges the FE rename while the BE migration is pending (PLA-2115).
 * Remove once BE completes the event rename migration.
 */
const EVENT_TITLE_MAP: Record<string, string> = {
  "Engagement archived": "Assignment archived",
  "Engagement restored": "Assignment restored",
  "Engagement eligible for payments": "Assignment eligible for payments",
  "Engagement ineligible for payments": "Assignment ineligible for payments",
  "Engagement added": "Assignment added"
};

export const mapEventTitle = (title: string): string =>
  EVENT_TITLE_MAP[title] ?? title;
